import type { ItemOption } from "./types/item.js";

export function normalizeItemTags(tags: string[]): string[] {
  const normalized: string[] = [];
  const seen = new Set<string>();

  for (const tag of tags) {
    const trimmed = tag.trim();
    if (!trimmed || seen.has(trimmed)) {
      continue;
    }

    seen.add(trimmed);
    normalized.push(trimmed);
  }

  return normalized;
}

export function normalizeItemOptions(options: ItemOption[]): ItemOption[] {
  const normalized: ItemOption[] = [];
  const seen = new Set<string>();

  for (const option of options) {
    const key = option.key.trim();
    const value = option.value.trim();
    if (!key || !value) {
      continue;
    }

    const dedupeKey = `${key}\u0000${value}`;
    if (seen.has(dedupeKey)) {
      continue;
    }

    seen.add(dedupeKey);
    normalized.push({ key, value });
  }

  return normalized;
}